import { EWantTypeId, TWantType } from 'shared/types/wantType';

export const WANT_KNOW_TYPE: TWantType[] = [
  {
    id: EWantTypeId.Sell,
    text: 'Продажу',
    imgClass: 'crown',
  },
  {
    id: EWantTypeId.Rent,
    text: 'Аренду',
    imgClass: 'cat',
  },
];
